






























































































































































import { Component } from 'vue-property-decorator';
import { SwExtendedVue } from '@libs-uuif/shared/sw-extended-vue';
import uuifComponent from '@/shared/uuifComponent';
import { ColumnSortRequestData, SortedColumnInfo, SwTable, TableColumnConfig, TableData } from '@sonicwall/unified-ui-framework/src/shared/sw-table';
import ProcessNfrDialog from './components/process-nfr-request.vue';
import { SwScrollView } from '@sonicwall/unified-ui-framework/src/shared/sw-scroll-view';
import { ContentToolbarExpandFilterBlock, SwContentToolbar, SwContentToolbarExpand } from '@sonicwall/unified-ui-framework/src/shared/sw-content-toolbar';
import { SwExpandableTextfield, SwTextfield } from '@sonicwall/unified-ui-framework/src/shared/sw-textfield';
import { SwIconButton } from '@sonicwall/unified-ui-framework/src/shared/sw-icon-button';
import { CreateElement, VNode } from 'vue';
import _ from 'lodash';
import { MswAppTitle } from '@/shared/msw-app-title';

const cssPrefix = 'nfr-service';

@Component({
  components: {
    ...uuifComponent,
    ProcessNfrDialog,
    SwScrollView,
    SwContentToolbar,
    SwExpandableTextfield,
    SwIconButton,
    SwContentToolbarExpand,
    SwTextfield,
    MswAppTitle,
  },
})
export default class NfrService extends SwExtendedVue {
  cssPrefix =  cssPrefix;
  showProcessNfrDialog: boolean  = false;
  nfrProcessData : any;
  searchInputText : string = '';
  isExpandSearchFilter : boolean = false;
  expandVisible : boolean = false;
  nameValue : string = '';
  serialNumberValue : string = '';
  descriptionValue : string  = '';
  filterApplied : boolean = false;
  sortedColumns: SortedColumnInfo[] = [];
  nfrServiceColumConfig : TableColumnConfig[] = [{
    key: 'selection',
    type: 'selection',
  },
  {
    key: 'index',
    type: 'index',
  },
  {
    key: 'nfrFriendlyName',
    dataKey : 'nfrFriendlyName',
    title : this.$t('products.name')
    .toString(),
    sorter: true,
  },
  {
    key: 'nfrSerialNumber',
    dataKey : 'nfrSerialNumber',
    title : this.$t('products.serialnumber')
    .toString(),
    sorter: true,
  },
  {
    key: 'nfrDescription',
    dataKey : 'nfrDescription',
    title : this.$t('common.description')
    .toString(),
    sorter: true,
  }];
  nfrServiceData : TableData[] = [];
  nfrServiceFilteredData : TableData[] = [];
  selectedRows : any[] = [];
  snbUser : any = '';

  created() {
    this.getNfrList();
    this.snbUser = this.$router.currentRoute.query.snbuser ? this.$router.currentRoute.query.snbuser : '';
  }

  getNfrList() {
    this.selectedRows = [];
    this.$store.dispatch('NfrServiceStoreStateModule/getNFRList')
    .then((response : any) => {
      this.$store.commit('stopLoading');
      this.nfrServiceData = response.content.nfrSerialNumberHistory.  map((ele : any,  index : any) => {
        ele._key = index.toString();
        ele._selectable = ele.nfrIscheckBoxNeeded;
        return ele;
      });
      console.warn(this.nfrServiceData);
    });
  }

  get basicInitSelectedIds() {
    return [];
  }

  viewHistory() {
    this.$router.push('/m/feature/nfrhistory');
  }

  applyNfr() {
    this.nfrProcessData = { nfrServiceRowData : this.nfrServiceData , selected : this.selectedRows };
    this.showProcessNfrDialog =  true;
  }

  onRequestSorting(data: ColumnSortRequestData) {
    data.cancel = false;
    const index = this.sortedColumns.findIndex(col => (col.colKey === data.colKey));
    if (index < 0) {
      if (data.cancel) { return; }
      this.sortedColumns.splice(0);
      this.sortedColumns.push({
        colKey: data.colKey,
        ascending: !!data.ascending,
      });
    } else {
      if (data.ascending === undefined) {
        this.sortedColumns[index].ascending = !this.sortedColumns[index].ascending;
        return;
      }
      this.sortedColumns[index].ascending = !!data.ascending;
    }
  }

  refresh() {
    this.clearSelectedRows();
    this.filterApplied = false;
    this.expandVisible = false;
    this.searchInputText = '';
    this.nameValue = '';
    this.serialNumberValue = '';
    this.descriptionValue = '';
    this.getNfrList();
  }

  clearSelectedRows() {
    this.selectedRows = [];
    const vm = this.$refs.nfrTable as SwTable;
    if (vm) {
      vm.selectedSet.clear();
    }
    this.nfrServiceData = this.nfrServiceData.slice();
  }

  onEntrySelecting(event : any) {
    if (event.selecting) {
      this.selectedRows.push(event.entryKey);
    } else {
      const index = this.selectedRows.indexOf(event.entryKey);
      if (index > -1) {
        this.selectedRows.splice(index, 1);
      }
    }
  }

  closeDialog(event : any) {
    this.showProcessNfrDialog =  false;
    if (event) {
      this.getNfrList();
    }
  }

  get tableHeight() {
    return 'calc(100vh - 425px)';
  }

  get filterBlockGrid() : ContentToolbarExpandFilterBlock[][] {
    return [
      [
        {
          title: this.$t('products.name')
          .toString(),
          content: this.nameFilterRender,
          width: 320,
        },
        {
          title: this.$t('products.serialnumber')
          .toString(),
          content: this.serialNumberFilterRender,
          width: 320,
        },
        {
          title: this.$t('common.description')
          .toString(),
          content: this.descriptionFilterRender,
          width: 320,
        },
      ],
    ];
  }

  private nameFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'name',
              value: this.nameValue,
              placeholder: this.$t('products.name')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('name', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private serialNumberFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'serialNumber',
              value: this.serialNumberValue,
              placeholder: this.$t('products.serialnumber')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('serialNumber', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }
  private descriptionFilterRender(h: CreateElement): VNode { // tslint:disable-line
    return (
      <div>
        <SwTextfield
          {...{
            props: {
              name: 'description',
              value: this.descriptionValue,
              placeholder: this.$t('common.description')
              .toString(),
            },
            style: {
              width: '200px',
            },
            on: {
              keyup: (event: any) => {
                if (event.keyCode === 13) {
                  this.applyFilters();
                }
              },
              input: (event: any) => {
                this.mutateFilterState('description', event.trim());
              },
            },
          }}
        ></SwTextfield>
      </div>
    ) as VNode;
  }

  onToggleFilterExpand() {
    this.expandVisible = !this.expandVisible;
  }

  mutateFilterState(name: any, event: any) {
    switch (name) {
      case 'name':
        this.nameValue = event;
        break;
      case 'serialNumber':
        this.serialNumberValue = event;
        break;
      case 'description':
        this.descriptionValue = event;
        break;
      case 'searchInputText':
        this.searchInputText = event;
        break;
    }
    if (!this.nameValue && !this.serialNumberValue && !this.searchInputText && !this.descriptionValue) {
      this.filterApplied = false;
    }
  }

  applyFilters() {
    this.nfrServiceFilteredData = _.filter(this.nfrServiceData, (o : any) => {
      let flag = true;
      if (this.nameValue !== '' && o.nfrFriendlyName.toLowerCase()
      .indexOf(this.nameValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.serialNumberValue !== '' && o.nfrSerialNumber.toLowerCase()
      .indexOf(this.serialNumberValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (this.descriptionValue !== '' && o.nfrDescription.toLowerCase()
      .indexOf(this.descriptionValue.toLowerCase()) === -1) {
        flag = false;
      }
      if (flag) {
        return o;
      }
    }) as TableData[];
    this.filterApplied =  true;
    console.warn('adpplied filter');
  }

  removeFilter(param : any, val : any) {
    this.mutateFilterState(param, val);
    if (this.filterApplied) {
      this.applyFilters();
    }
  }

  handleSearchFilter() {
    if (this.searchInputText.trim() === '') {
      return;
    }
    this.nfrServiceFilteredData = _.filter(this.nfrServiceData, (o : any) => {
      let flag = false;
      if (o.nfrFriendlyName.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.nfrSerialNumber.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1 || o.nfrFriendlyName.toLowerCase()
      .indexOf(this.searchInputText.toLowerCase()) > -1) {
        flag = true;
      }
      if (flag) {
        return o;
      }
    }) as TableData[];
    this.filterApplied =  true;
  }
}
